export default "__VITE_ASSET__BMtcRZWI__"